


































































































import { COLOR_BASE_DIALOG_BACKGROUND, COLOR_BASE_DIALOG_BACKGROUND_DARK } from "@/utils/colors";
import { themed } from "@/utils/Theme";
import { Component, Vue, Watch, Prop } from "vue-property-decorator";

interface UserBaseDialogOptions {
  title: string;
  positiveButtonText?: string | null;
  negativeButtonText?: string | null;
  neutralButtonText?: string | null;

  leftButtonText?: string | null;
  midButtonText?: string | null;
  rightButtonText?: string | null;

  scrollable?: boolean;
  maxWidth?: number;
  closeOnSave?: boolean;
  closeOnNeutralAction?: boolean;
  closeOnNegativeAction?: boolean;

  closeOnLeftAction?: boolean;
  closeOnMidAction?: boolean;
  closeOnRightAction?: boolean;

  persistent?: boolean;
  styleAsAlertDialog?: boolean;
  startedForUserCreation?: boolean;
  isVehicleDialog?: boolean;
}

@Component
export default class UserBaseDialogComponent extends Vue {
  isShowing = false;

  @Prop({ default: false })
  saveDisabled!: boolean;

  @Prop({ default: false })
  loading!: boolean;

  @Prop({ default: false })
  dataChange!: boolean;

  @Watch("isShowing")
  onIsShowingChanged(newValue: boolean) {
    if (newValue) {
      this.$emit("onDialogOpened");
    } else {
      this.$emit("onDialogClosed");
    }
  }

  @Watch("dataChange")
  onDataChanged(newValue: boolean) {
    this.change = newValue;
  }

  get negativeButtonText_() {
    return this.dataChange
      ? this.$t("common.abort").toString()
      : this.$t("common.close").toString()
  }

  change = false;
  title = "";
  positiveButtonText = "";
  negativeButtonText = "";
  neutralButtonText = "";

  leftButtonText = "";
  midButtonText = "";
  rightButtonText = "";

  maxWidth = 600;

  styleAsAlertDialog = false;

  scrollable = true;

  closeOnSave = true;
  closeOnNeutralAction = true;
  closeOnNegativeAction = true;

  closeOnLeftAction = true;
  closeOnMidAction = true;
  closeOnRightAction = true;

  persistent = false;

  showPositiveButton = true;
  showNegativeButton = true;
  showNeutralButton = true;

  startedForUserCreation = false;
  isVehicleDialog = false;

  showLeftButton = true;
  showMidButton = true;
  showRightButton = true;

  show(options: UserBaseDialogOptions) {
    this.isShowing = true;

    this.styleAsAlertDialog = options.styleAsAlertDialog ?? false;
    this.title = options.title;

    this.maxWidth = options.maxWidth ?? 600;
    this.scrollable = options.scrollable ?? false;
    this.isVehicleDialog = options.isVehicleDialog ?? false;

    this.showPositiveButton = options.positiveButtonText !== null;
    this.showNegativeButton = options.negativeButtonText !== null;

    this.showLeftButton = options.leftButtonText !== null;
    this.showMidButton = options.midButtonText !== null;
    this.showRightButton = options.rightButtonText !== null;

    this.showNeutralButton = !!options.neutralButtonText;

    this.startedForUserCreation = options.startedForUserCreation ?? false;

    this.positiveButtonText =
      options.positiveButtonText ?? this.$t("common.save").toString();
    this.negativeButtonText =
      options.negativeButtonText ?? this.$t("common.close").toString();

    this.neutralButtonText = options.neutralButtonText ?? "";

    this.leftButtonText = options.leftButtonText ?? "";
    this.midButtonText = options.midButtonText ?? "";
    this.rightButtonText = options.rightButtonText ?? "";

    this.persistent = options.persistent ?? false;

    this.closeOnNeutralAction = options.closeOnNeutralAction ?? true;
    this.closeOnNegativeAction = options.closeOnNegativeAction ?? true;

    this.closeOnLeftAction = options.closeOnLeftAction ?? true;
    this.closeOnMidAction = options.closeOnMidAction ?? true;
    this.closeOnRightAction = options.closeOnRightAction ?? true;

    this.closeOnSave = options.closeOnSave ?? true;
  }

  onPositiveAction() {
    if (this.closeOnSave) {
      this.isShowing = false;
    }

    this.$emit("positiveAction");
  }

  onNegativeAction() {
    if (this.closeOnNegativeAction) {
      this.isShowing = false;
    }

    this.$emit("negativeAction");
  }

  onNeutralAction() {
    if (this.closeOnNeutralAction) {
      this.isShowing = false;
    }

    this.$emit("neutralAction");
  }

  onLeftAction() {
    if (this.closeOnLeftAction) {
      this.isShowing = false;
    }
    this.$emit("leftAction");
  }
  onMidAction() {
    if (this.closeOnMidAction) {
      this.isShowing = false;
    }
    this.$emit("midAction");
  }

  onRightAction() {
    if (this.closeOnRightAction) {
      this.isShowing = false;
    }
    this.$emit("rightAction");
  }

  onCancel() {
    this.$emit("cancel");
  }

  get style() {
    return this.styleAsAlertDialog
      ? ""
      : `background: ${themed(COLOR_BASE_DIALOG_BACKGROUND, COLOR_BASE_DIALOG_BACKGROUND_DARK)}`;
  }
}
